import React, { useEffect, useMemo, useState } from "react";
import {
  FormActionComponent,
  FormWrapperInputComponent,
  FormWrapperItem,
  HeaderComponent,
  HeaderListComponent,
  PageListComponent,
} from "containers/backend/common/component/Index";
import { capitalizeFirstLetter } from "helpers/functions";
import Wrapper from "containers/backend/common/component/Wrapper";
import { DATE_TIME_FORMAT, PATHS } from "constants/Define";
import { isEmpty } from "lodash";
import moment from "moment";
import { Alert, Table } from "antd";
import CalendarRender from "containers/backend/common/component/CalendarRender";
import "./styles.less";
import { useParams } from "react-router-dom";
import { getMomentDate } from "utils/commonUtils";
import useGetUsagePlanDetail from "hooks/suppliers/useGetUsagePlanDetail";
import Switch from "containers/backend/common/component/Switch";
const propTypes = {};

const SupplierUsagePlanDetail = (props) => {
  //! State
  const { t, match, history } = props;
  const params = useParams();
  // const [query, setQuery] = useState({
  //   pageIndex: 1,
  //   pageSize: 10
  // })
  const [toggle, setToggle] = useState(false);

  // const {
  //   usagePlan,
  //   loading: loadingInventory,
  //   setUsagePlan,
  // } = useGetUsagePlanDetail(params.id, query);
  const {
    usagePlan,
    loading: loadingInventory,
    setUsagePlan,
  } = useGetUsagePlanDetail(params.id);
  const [dateRangeCalendar, setDateRangeCalendar] = useState([]);
  const [calendarValueParsed, setCalendarValueParsed] = useState([]);
  const {
    productCode,
    productWarehouseGoodReceipts,
    supplierProductUsagePlans,
    // pageIndex,
    // pageSize,
    // totalCount
  } = usagePlan;

  const columns = useMemo(() => {
    return [
      {
        title: t(`item.supplier.productWarehouseGoodReceipts.goodReceiptCode`),
        dataIndex: "goodReceiptCode",
        key: "goodReceiptCode",
      },
      {
        title: t(`item.supplier.productWarehouseGoodReceipts.usedTime`),
        dataIndex: "usedTime",
        key: "usedTime",
        render: (date, record) =>
          `${moment(moment.utc(record?.usedDateFrom).toDate()).format(
            DATE_TIME_FORMAT.SHORT_DATE_MONTTH
          )} - ${moment(moment.utc(record?.usedDateTo).toDate()).format(
            DATE_TIME_FORMAT.SHORT_DATE_MONTTH
          )}`,
      },
      {
        title: t(`item.supplier.productWarehouseGoodReceipts.quantity`),
        dataIndex: "quantity",
        key: "quantity",
      },
      {
        title: t(`item.supplier.productWarehouseGoodReceipts.planedQuantity`),
        dataIndex: "planedQuantity",
        key: "planedQuantity",
      },
      {
        title: t(`item.supplier.productWarehouseGoodReceipts.soldQuantity`),
        dataIndex: "soldQuantity",
        key: "soldQuantity",
      },
      {
        title: t(`item.supplier.productWarehouseGoodReceipts.expiredQuantity`),
        dataIndex: "expiredQuantity",
        key: "expiredQuantity",
      },
      {
        title: t('item.supplier.productWarehouseGoodReceipts.usedQuantity'),
        dataIndex: "usedQuantity",
        key: "usedQuantity"
      },
      {
        title: t(
          `item.supplier.productWarehouseGoodReceipts.availableQuantity`
        ),
        dataIndex: "availableQuantity",
        key: "availableQuantity",
      },
    ];
  }, [t]);

  //! Effect
  useEffect(() => {
    const { productWarehouseGoodReceipts = [] } = usagePlan || {};

    const startDateList = productWarehouseGoodReceipts.map(x=>getMomentDate(x.usedDateFrom));
    const endDateList = productWarehouseGoodReceipts.map(x=>getMomentDate(x.usedDateTo));

    const startDate = moment.min(startDateList);
    const endDate = moment.max(endDateList);

    if (startDate && endDate) {
      setDateRangeCalendar([startDate, endDate]);
      setCalendarValueParsed([startDate, endDate]);
    }
  }, [usagePlan]);

  //! Function
  const getTitleHeader = () => {
    return capitalizeFirstLetter(
      `${t("navigation.productUsageHistory")}`.toLowerCase()
    );
  };

  const onClickBack = () => {
    history.push({
      pathname: PATHS.SUPPLIER.LIST.path,
      state: { isTab: "PRODUCT" },
    });
  };

  const onChangeTotalQuantiy = (e) => {
    setToggle(!toggle);
  };

  const getTitleSwitch = () => {
    return toggle
      ? `${t(`item.supplier.productWarehouseGoodReceipts.used`)}`
      : `${t(`item.supplier.productWarehouseGoodReceipts.plan`)}`;
  };

  const onChangeCalendar = (dateRange) => {
    setCalendarValueParsed(dateRange);
  }

  //! Render
  return (
    <PageListComponent>
      <HeaderListComponent
        path={match.path}
        groupPath={"warehousemanagement"}
        titleHeader={getTitleHeader()}
      />
      <FormActionComponent
        disableButtonSubmit
        onClickBack={() => onClickBack()}
      >
        <FormWrapperItem>
          <HeaderComponent
            title={`${t("navigation.productUsageHistory")}: ${
              productCode ? productCode : ""
            }`}
            className="col-md-12 mb-3 p-2 m-b"
            style={{ borderBottom: "1px solid rgb(230, 230, 230)" }}
          />

          {/* TABLE */}
          <Wrapper className="col-md-12">
            <Table
              dataSource={usagePlan ? [...productWarehouseGoodReceipts] : []}
              columns={columns}
              loading={loadingInventory}
              rowKey="goodReceiptCode"
              // pagination={{
              //   total: totalCount,
              //   pageSize: pageSize,
              //   showSizeChanger: true,
              //   onShowSizeChange: (pageIndex, pageSize) => {setQuery({ ...query,pageIndex, pageSize })},
              //   onChange: (pageIndex, pageSize) => {
              //     setQuery({ ...query, pageIndex, pageSize })
              //   }
              // }}
            />
          </Wrapper>
          {/*  */}
          <Wrapper className="col-md-12 row">
            <div className="col-md-6 flex-center justify-end">
              <Alert message="Lưu ý: chỉ chỉnh sửa lịch khởi hành trong khoảng thời gian cho phép và với sản phẩm chưa bán hoặc chưa hết hạn sử dụng" type="info" showIcon />
            </div>
            <div className="col-md-6 flex-center justify-end">
              <FormWrapperInputComponent labelTitle={getTitleSwitch()}>
                <Switch
                  className="mx-2"
                  labelRight={false}
                  checked={toggle}
                  onChange={(e) => onChangeTotalQuantiy(e)}
                />
              </FormWrapperInputComponent>
            </div>
          </Wrapper>
          {/*  */}
          <Wrapper className="col-md-12">
            {calendarValueParsed.length > 0 && !isEmpty(supplierProductUsagePlans) && (
              <CalendarRender
                disablePopover
                enablePopup={false}
                value={calendarValueParsed}
                validRange={dateRangeCalendar}
                whPlanSales={supplierProductUsagePlans}
                defaultValueKey={toggle ? 'usedQuantity' : 'planQty'}
                isShowMultiple={true}
                onChangeCalendar={onChangeCalendar}
              />
            )}
          </Wrapper>
        </FormWrapperItem>
      </FormActionComponent>
    </PageListComponent>
  );
};

SupplierUsagePlanDetail.propTypes = propTypes;
export default SupplierUsagePlanDetail;
